import { Link } from 'react-router-dom';
import LegalDoc from '../components/LegalDoc';
import {
  HOSTING_DC_ADDRESS,
  HOSTING_INN,
  HOSTING_LEGAL_ADDRESS,
  HOSTING_NAME,
  HOSTING_OGRN,
  OFERTA_PATH,
  OPERATOR_EMAIL,
  OPERATOR_INN,
  OPERATOR_NAME,
  OPERATOR_OGRNIP,
  OPERATOR_OGRNIP_DATE,
  OPERATOR_PHONE,
  OPERATOR_REGION,
  POLICY_DATE,
  PROCESSING_START_DATE,
  SITES_LABEL,
  TERMS_PATH,
} from '../legal/operator';

export default function PrivacyPage() {
  return (
    <LegalDoc title="Политика обработки персональных данных">
      <p>
        Настоящая Политика определяет порядок обработки и защиты персональных данных
        пользователей сайта {SITES_LABEL} (далее — Сайт) в соответствии с Федеральным
        законом от 27.07.2006 № 152-ФЗ «О персональных данных».
      </p>
      <p>
        Актуальная редакция: {POLICY_DATE} Дата начала обработки:{' '}
        {PROCESSING_START_DATE} Уведомление оператора в Роскомнадзор № 77-26-566655.
        Названия целей ниже совпадают с этим уведомлением.
      </p>

      <h2>1. Оператор</h2>
      <p>
        Оператор персональных данных: {OPERATOR_NAME}.
      </p>
      <ul>
        <li>ИНН: {OPERATOR_INN}</li>
        <li>
          ОГРНИП: {OPERATOR_OGRNIP} (дата присвоения {OPERATOR_OGRNIP_DATE})
        </li>
        <li>Регион регистрации: {OPERATOR_REGION}</li>
        <li>
          Электронная почта для запросов субъектов ПДн:{' '}
          <a href={`mailto:${OPERATOR_EMAIL}`}>{OPERATOR_EMAIL}</a>
        </li>
        <li>Телефон: {OPERATOR_PHONE}</li>
      </ul>
      <p>
        Почтовый адрес для запросов на бумаге на Сайте не публикуется: направляйте
        обращения на указанную электронную почту. Ответ направляется на адрес, с
        которого получен запрос, либо на email учётной записи.
      </p>

      <h2>2. Сайт и люди</h2>
      <p>
        Посетитель — человек без учётной записи. Клиент — ученик, родитель или
        репетитор с учётной записью. Клиент может пользоваться Сайтом бесплатно.
        Платная услуга возникает, только если человек сам оплатил занятия или
        доступ к Сайту.
      </p>

      <h2>3. Цели, данные и основания</h2>
      <p>
        Состав данных зависит от того, чем человек пользуется. Посетитель без
        учётной записи не становится стороной договора и не получает платных услуг.
      </p>

      <h3>3.1. Работоспособность и безопасность Сайта</h3>
      <p>
        Данные: IP-адрес, сведения о браузере, журналы запросов, cookie сессии и
        защиты форм. Субъект: любой посетитель, в том числе без регистрации и без
        оплаты. Основание: законный интерес оператора. Журналы нужны, чтобы Сайт
        открывался, формы не подделывали и можно было разобрать сбой. Учётная
        запись по ним не создаётся, реклама по ним не показывается.
      </p>
      <p>
        Действия: сбор, запись, систематизация, накопление, хранение, уточнение
        (обновление, изменение), извлечение, использование, блокирование,
        обезличивание, удаление, уничтожение. Третьим лицам эти журналы отдельно
        не передаются. Способ: автоматизированная обработка, с передачей по сети
        Интернет. Срок: журналы хранятся на хостинге и удаляются при ротации.
      </p>

      <h3>3.2. Подготовка, заключение и исполнение гражданско-правового договора</h3>
      <p>
        Договор здесь — один из двух.{' '}
        <Link to={TERMS_PATH}>Пользовательское соглашение</Link>
        {' '}принимает каждый, кто регистрируется: оно про доступ к Сайту.{' '}
        <Link to={OFERTA_PATH}>Договор-оферта</Link>
        {' '}на занятия — отдельный документ. Родитель отмечает её как согласие на
        пробное занятие; договор на занятия заключается оплатой первого занятия.
        Регистрация ученика этот договор не заключает.
      </p>
      <p>
        Данные: фамилия, имя, отчество; адрес электронной почты; телефон, если
        указан; логин; хеш пароля; роль на Сайте; город, школа, класс; аватар;
        анкета, если её заполнили; решения задач, журнал занятий, сведения о
        присутствии на странице занятия, сообщения на Сайте; факт и дата согласия
        и принятия пользовательского соглашения.
      </p>
      <p>
        Субъект: клиент. Основания до оплаты первого занятия: пользовательское
        соглашение с этим человеком и его согласие. Согласие нужно для учебных
        сведений и анкеты: ученик не сторона оферты на занятия, а до оплаты
        договора на занятия ещё нет. Ученик с 14 лет соглашается сам. Если
        ученику нет 14 лет, согласие на его данные даёт родитель. После оплаты
        первого занятия к обработке учебных сведений добавляется основание —
        исполнение договора на занятия, по которому ученик — выгодоприобретатель.
      </p>
      <p>
        Анкета для входа на Сайт не нужна, её можно не заполнять. Вопрос о
        финансовых возможностях семьи относится только к анкете: это не сведения о
        доходе и не основание для скидки (ставка часа фиксированная). Ответ нужен,
        чтобы предложить режим занятий — регулярные, меньший объём или разовые
        консультации.
      </p>
      <p>
        Действия: сбор, запись, систематизация, накопление, хранение, уточнение
        (обновление, изменение), извлечение, использование, передача
        (предоставление) лицам из раздела 6, блокирование, обезличивание,
        удаление, уничтожение. Способ: автоматизированная обработка, с передачей
        по сети Интернет. Срок: пока цель достигнута или согласие отозвано, если
        для этой цели нет другого основания из раздела 3; после заключения договора
        на занятия — пока нужен для его исполнения.
      </p>

      <h3>3.3. Приём оплаты и обязанности по законодательству о расчётах</h3>
      <p>
        Данные: сумма, статус платежа, идентификатор платежа, email для чека,
        состав семейного счёта. Субъект: клиент, который сам инициировал платёж.
        Основания: договор, по которому он платит (оферта на занятия или платный
        доступ по пользовательскому соглашению), и законодательство Российской
        Федерации о расчётах. У посетителя и у клиента без платежа этих сведений нет.
      </p>
      <p>
        Платный доступ ученика или репетитора к Сайту включается с момента оплаты
        тарифа, опубликованного на Сайте. Пока тариф не опубликован, плата за
        доступ не берётся.
      </p>
      <p>
        Действия: сбор, запись, систематизация, накопление, хранение, уточнение
        (обновление, изменение), извлечение, использование, передача
        (предоставление) лицам из раздела 6, блокирование, обезличивание,
        удаление, уничтожение. Способ: автоматизированная обработка, с передачей
        по сети Интернет. Срок: в срок, установленный законодательством о расчётах.
      </p>

      <h3>3.4. Статистика посещаемости</h3>
      <p>
        Статистика посещаемости {SITES_LABEL} через Яндекс.Метрику, включая запись
        сессий (Вебвизор). Данные: IP-адрес, сведения о браузере и устройстве,
        cookie и идентификаторы счётчика. Субъект: посетитель. Основание: отдельное
        согласие в баннере cookie. Пока кнопка «Принять Метрику и Вебвизор» не
        нажата, счётчик не загружается.
      </p>
      <p>
        Действия: сбор, запись, систематизация, накопление, хранение, уточнение
        (обновление, изменение), извлечение, использование, передача
        (предоставление) ООО «Яндекс», блокирование, обезличивание, удаление,
        уничтожение. Способ: автоматизированная обработка, с передачей по сети
        Интернет. Срок: пока действует согласие в баннере cookie; после отзыва
        счётчик перестаёт загружаться, cookie Метрики сбрасываются.
      </p>

      <h2>4. Cookie и локальные данные браузера</h2>
      <p>
        Cookie сессии и защиты форм (CSRF) ставятся всегда: без них личный кабинет
        и формы не работают. Это цель из раздела 3.1, не Метрика.
      </p>
      <p>
        Яндекс.Метрика включается только после явного согласия в баннере
        («Принять Метрику и Вебвизор»): cookie счётчика, карта кликов и Вебвизор.
        Рекламных сетей и Google Analytics нет. Кнопка «Только необходимые»
        оставляет cookie сессии и CSRF, счётчик при этом не загружается.
      </p>
      <p>
        Согласие на аналитику хранится в браузере (localStorage). Отозвать его можно
        ссылкой «Настройки cookie» в подвале Сайта: баннер откроется снова, cookie
        Метрики будут сброшены, счётчик перестанет загружаться.
      </p>
      <p>
        Тема оформления может храниться в браузере. Черновик решения сохраняется
        в кабинете, если включено автосохранение.
      </p>

      <h2>5. Действия и способы</h2>
      <p>
        Сбор, запись, систематизация, накопление, хранение, уточнение (обновление,
        изменение), извлечение, использование, передача (предоставление) лицам из
        раздела 6, блокирование, обезличивание, удаление, уничтожение. Журналы
        безопасности отдельно третьим лицам не передаются.
      </p>
      <p>
        Способы: автоматизированная обработка, с передачей по сети Интернет, без
        передачи по внутренней сети юридического лица (оператор — индивидуальный
        предприниматель).
      </p>
      <p>
        При удалении учётной записи из неё убираются сведения, по которым можно
        узнать человека: адрес электронной почты, ФИО, телефон, контакты, аватар
        и иные идентификаторы. Обезличенная статистика решений может сохраниться.
        Сведения об оплате хранятся, пока этого требует закон о расчётах.
      </p>

      <h2>6. Кому попадают данные</h2>
      <p>Данные не продаются.</p>
      <ul>
        <li>
          Хостинг {HOSTING_NAME} (ИНН {HOSTING_INN}, ОГРН {HOSTING_OGRN}): база
          данных граждан РФ размещена в ЦОД по адресу {HOSTING_DC_ADDRESS};
          адрес организации: {HOSTING_LEGAL_ADDRESS}. Это поручение оператора.
          Собственного ЦОД у оператора нет. Облачное хранение и CRM-система не
          используются.
        </li>
        <li>
          ООО «Яндекс»: Яндекс.Метрика и Вебвизор после согласия в баннере;
          почтовые письма; Яндекс&nbsp;Телемост, если занятие идёт через этот сервис.
        </li>
        <li>
          Платёжный сервис (Озон Пай): email для чека, сумма и назначение, когда
          человек сам инициирует оплату.
        </li>
        <li>
          «Макс» или ВКонтакте, если пользователь сам указал этот канал или включил
          уведомления бота «Макс».
        </li>
      </ul>
      <p>
        По законному требованию государственного органа РФ сведения предоставляются
        в объёме этого требования.
      </p>
      <p>
        Трансграничная передача персональных данных не осуществляется. Скрипты,
        шрифты и среда выполнения кода размещены на Сайте, серверы в Российской
        Федерации.
      </p>

      <h2>7. Срок</h2>
      <p>
        Первичный сбор, запись и хранение персональных данных граждан РФ выполняются
        на серверах на территории Российской Федерации (ЦОД {HOSTING_NAME}, Москва).
        Обработка ведётся с {PROCESSING_START_DATE}
      </p>
      <p>
        Обработка по конкретной цели прекращается, когда цель достигнута или
        согласие отозвано, если для этой цели нет другого основания из раздела 3.
        Сведения об оплате хранятся дольше, в срок, установленный законодательством
        о расчётах. Резервные копии на том же хостинге удаляются по мере ротации.
      </p>

      <h2>8. Меры защиты</h2>
      <p>
        Обработку веду лично я как оператор. Доступ к базе и административным
        функциям Сайта имею только я. Применяются парольная защита устройств,
        антивирусное программное обеспечение, протокол HTTPS, резервное копирование
        базы на хостинге, ограничение доступа посторонних лиц к рабочему компьютеру.
        Сертифицированные средства криптографической защиты информации не
        используются. При обработке в информационной системе обеспечивается 4-й
        уровень защищённости персональных данных (постановление Правительства РФ
        от 01.11.2012 № 1119), актуальны угрозы 3-го типа.
      </p>
      <p>
        Ответственный за организацию обработки персональных данных — оператор
        ({OPERATOR_NAME}).
      </p>

      <h2>9. Права пользователя</h2>
      <p>
        Вы вправе запросить доступ, уточнение, блокирование или удаление своих
        персональных данных, а также отозвать согласие. Для этого напишите на{' '}
        <a href={`mailto:${OPERATOR_EMAIL}`}>{OPERATOR_EMAIL}</a>
        {' '}с адреса, указанного в профиле, либо приложите данные, по которым можно
        опознать учётную запись. Ответ направляется в срок не позднее 10 рабочих
        дней (ст.&nbsp;14 Федерального закона №&nbsp;152-ФЗ), если закон не
        предусматривает иной срок.
      </p>
      <p>
        Факт согласия при регистрации фиксируется: время, IP-адрес, версия текста
        согласия. Принятие пользовательского соглашения и договор-оферты
        фиксируется так же. Согласие на Яндекс.Метрику отзывается через «Настройки
        cookie» в подвале. Часть сведений можно изменить в разделе «Профиль».
      </p>
      <p>
        Удаление учётной записи можно запросить в профиле («Удалить аккаунт
        навсегда»), если нет непогашенного баланса. Вход закрывается сразу, данные
        удаляются в течение 10 дней: убираются сведения, по которым можно узнать
        человека, обезличенная статистика решений может сохраниться. Тот же запрос
        можно отправить письмом. Отзыв согласия не останавливает хранение сведений
        об оплате в срок, установленный законом, и не отменяет обработку, которая
        нужна для уже заключённого договора.
      </p>

      <h2>10. Несовершеннолетние</h2>
      <p>
        Сайт используется для подготовки школьников к ОГЭ и ЕГЭ.
      </p>
      <p>
        Ученик с 14 лет даёт согласие на обработку своих персональных данных сам
        и сам принимает пользовательское соглашение. Согласие родителя на эти
        данные не требуется.
      </p>
      <p>
        Если ученику нет 14 лет, сам он согласие не даёт. Родитель даёт отдельное
        согласие на данные ребёнка, принимает пользовательское соглашение для его
        аккаунта и отправляет ссылку, по которой ребёнок создаёт учётную запись.
      </p>
      <p>
        Родитель принимает договор-оферту как согласие на пробное занятие.
        Договор на занятия заключается оплатой первого занятия. Регистрация
        ученика этот договор не заключает.
      </p>

      <h2>11. Изменения политики</h2>
      <p>
        Актуальная редакция всегда доступна на этой странице. Дата редакции указана
        в начале документа.
      </p>
    </LegalDoc>
  );
}
